var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTooltipInverse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.58 -271.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-288.58,272.008a5.25,5.25,0,0,1,5.25,5.248v0a5.249,5.249,0,0,1-5.25,5.25,5.251,5.251,0,0,1-5.25-5.25,5.256,5.256,0,0,1,5.25-5.25m0-.75a6,6,0,0,0-6,6,6,6,0,0,0,6,6,6,6,0,0,0,6-6A6,6,0,0,0-288.58,271.258Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.44,
    height: 1.3,
    transform: "translate(-289.3 273.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.44,
    height: 4.71,
    transform: "translate(-289.3 276.55)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTooltipInverse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tooltip-inverse.243e09c47d108f3904728e5da00b62c1.svg";